module.exports = __webpack_public_path__ + "img/happy_money.b503e1c1.png";